'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconWebviHost, iconWebviHostTag } from '@ni/nimble-components/dist/esm/icons/webvi-host';
import { wrap } from '../../utilities/react-wrapper';

export type { IconWebviHost };
export { iconWebviHostTag };
export const NimbleIconWebviHost = wrap(IconWebviHost);